module.exports = "<div>\n    <input id=\"email\" name=\"login_email\" type=\"email\" value=\"\" autocomplete=\"off\" placeholder=\"Email\" style=\"display:none\">\n    <input id=\"password\" name=\"login_password\" type=\"password\" value=\"\" placeholder=\"Password\" style=\"display:none\">\n    <div id=\"injectedUnifiedLogin\">\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-login-components/src/unified-login/template.html
// module id = ../node_modules/xo-login-components/src/unified-login/template.html
// module chunks = 0